module.exports = __webpack_public_path__ + "img/case3.2012d229.png";